<template>
    <div class="popup">
      <div class="mask"></div>
      <div class="box"
          :class="styleConfig?.[currentStyle]?.box.class">
        <!-- 盒子背景层 -->
        <div class="box-bg"
            :class="styleConfig?.[currentStyle]?.boxBg.class">
          <img
            v-if="currentStyle === 0"
            :src="require('@/assets/images/YuliApp/weeklyTask/long_popup_bg.svg')"/>
          <img
            v-if="currentStyle !== 0"
            :src="require('@/assets/images/YuliApp/weeklyTask/popup_bg.png')"/>
        </div>
        <!-- 关闭图标 -->
        <div class="box-closeIcon" @click="closeHandle" v-if="currentStyle === 1">
          <img
            src="@/assets/images/YuliApp/weeklyTask/icon_delete_nor.svg"
          />
        </div>
        <!-- 标题 -->
        <div class="box-title"
            :style="[{width: `${currentStyle === 4?'88%':''}`}]">
          {{styleConfig?.[currentStyle]?.title}}
        </div>
        <!-- 描述 -->
        <div class="box-describe" v-if="currentStyle === 0">
          <!-- Spend {{arg_use?.need}} ART to upgrade and get a reward worth <span class="box-describe-up-text">more than {{arg_use?.need}} ART！</span> -->
          <span v-if="localesEnv == 'ja'">
            {{ `${arg_use?.need} ART ${localesPackage?.['katharsis_upgrade_spend']?.[localesEnv]} ${localesPackage?.['katharsis_upgrade_toup_and']?.[localesEnv]}` }}<span class="box-describe-up-text">{{arg_use?.need}} ART！ {{ localesPackage?.['katharsis_upgrade_more']?.[localesEnv] }} {{ localesPackage?.['katharsis_upgrade_get_worth']?.[localesEnv] }}</span>
          </span>
          <span v-else>
            {{ `${localesPackage?.['katharsis_upgrade_spend']?.[localesEnv]} ${arg_use?.need} ART ${localesPackage?.['katharsis_upgrade_toup_and']?.[localesEnv]} ${localesPackage?.['katharsis_upgrade_get_worth']?.[localesEnv]}` }}<span class="box-describe-up-text">{{ localesPackage?.['katharsis_upgrade_more']?.[localesEnv] }} {{arg_use?.need}} ART！</span>
          </span>
        </div>
        <div class="box-describe-prop" v-if="currentStyle === 1">
          <div class="box-describe-prop-item">
            <PropItem
              :prop_number="cur_popup_info?.reward_num"
              :prop_type="cur_popup_info?.prop_level"
              :prop_img="cur_popup_info?.icon_url"
            ></PropItem>
          </div>
          <div class="box-describe-prop-title">{{ cur_popup_info?.name.replace(/"/g, "") }}</div>
          <div class="box-describe-prop-describe">{{ cur_popup_info?.desc.replace(/"/g, "") }}</div>
        </div>
        <div class="box-describe-error" v-if="currentStyle === 2">
          <!-- error_info?.msg -->
          <div class="box-describe-error-msg">{{ error_info?.msg || '' }}</div>
          <img :src="require('@/assets/images/YuliApp/weeklyTask/robot_error.svg')">
        </div>
        <div class="box-describe-congratulate" v-if="currentStyle === 3">
          <div class="box-describe-congratulate-title">{{ styleConfig?.[currentStyle]?.desc[0] }}</div>
          <div class="box-describe-congratulate-text">{{ styleConfig?.[currentStyle]?.desc[1] }}</div>
          <!-- robot_bell -->
          <img :src="require('@/assets/images/YuliApp/weeklyTask/robot_bell.svg')">
        </div>
        <div class="box-describe-howto" 
             v-if="currentStyle === 4"
             :style="[{top: `${localesEnv == 'zh' || localesEnv == 'zh_cn' ? '45%':''}`}]">
          <div class="box-describe-howto-desc">
            <div>{{ styleConfig?.[currentStyle]?.desc[0] }}</div>
            <!-- <div>{{ styleConfig?.[currentStyle]?.desc[1] }}</div> -->
          </div>
          <div class="box-describe-howto-content">
            <div class="box-describe-howto-content-box">{{ styleConfig?.[currentStyle]?.content[0] }}</div>
            <div class="box-describe-howto-content-box">{{ styleConfig?.[currentStyle]?.content[1] }}</div>
            <div class="box-describe-howto-content-box">{{ styleConfig?.[currentStyle]?.content[2] }}</div>
          </div>
          <div class="box-describe-howto-desc">
            <div>{{ styleConfig?.[currentStyle]?.desc[1] }}</div>
          </div>
        </div>
        <div class="box-describe-rules" v-if="currentStyle === 5">
          <div class="box-describe-rules-textgroup"
               v-for="group in styleConfig?.[currentStyle]?.content"
               :key="group[0]?.text">
              <div 
                  :class="[`box-describe-rules-textgroup-${item?.type}`]"
                   v-for="item in group"
                  :key="item?.text">
                  {{ item?.text }}
              </div>
          </div>
        </div>
        <!-- 奖励标题 -->
        <div class="box-reward-title" v-if="currentStyle === 0">{{localesPackage?.['og_pro_reward']?.[localesEnv]}}</div>
        <!-- 奖励盒子 -->
        <div class="box-rewardBox"
            :class="[{'box-single': pro_prop_list?.length == 1}]"
            v-if="currentStyle === 0"
        >
          <PropItem
            v-for="item in pro_prop_list"
            :key="item?.id"
            :prop_number="item?.reward_num"
            :prop_type="item?.prop_level"
            :prop_img="item?.icon_url"
            :propStyle="{'marginRight': 'auto',...item.proStyle}"
          ></PropItem>
        </div>
        <!-- 总额 -->
        <div class="box-count" v-if="currentStyle === 0">
          <span>ART: </span>
          <img :src="require('@/assets/images/YuliApp/weeklyTask/Art.png')">
          <span>{{ arg_use?.need }}</span>
        </div>
        <!-- 按钮层 -->
        <!-- UPGrade -->
        <div class="box-buttonView" v-if="currentStyle === 0">
          <div class="box-buttonView-button" @click="closeHandle">{{localesPackage?.['og_cancel_button']?.[localesEnv]}}</div>
          <div class="box-buttonView-button box-buttonView-confirm" @click="debounce(confirmHanle,300)()">{{localesPackage?.['og_confirm_button']?.[localesEnv]}}</div>
        </div>
        <!-- Prop -->
        <div class="box-buttonView box-prop-buttonView" v-if="currentStyle === 1">
          <div class="box-buttonView-button box-buttonView-prop" @click="infoHandle('upgrade')">{{localesPackage?.['og_unlock_button']?.[localesEnv]}}</div>
        </div>
        <!-- error -->
        <div class="box-buttonView box-prop-buttonView" v-if="currentStyle === 2">
          <div class="box-buttonView-button box-buttonView-error" @click="errorClose">{{localesPackage?.['og_quit_button']?.[localesEnv]}}</div>
        </div>
        <!-- og_con -->
        <div class="box-buttonView box-prop-buttonView" v-if="currentStyle === 3 || currentStyle === 4 || currentStyle === 5">
          <div class="box-buttonView-button box-buttonView-og_con" @click="closeHandle">{{localesPackage?.['katharsis_got_button']?.[localesEnv]}}</div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
  import _ from "lodash";
  import audioManager from "@/utils/audioManager";
  import PropItem from "./components/PropItem";
  import { POPUP_TYPE } from "@/constants/enums";
  import { mapState } from "vuex";

  export default {
    components: {
      PropItem
    },
    props: {
      popup_type: {
        type: Number,
        default: POPUP_TYPE.UPGRADE,
      },
      cur_popup_info: {
        type: Object,
        default: null,
      },
      arg_use: {
        type: Object,
        default: ()=>{
          return {
            need: 500,
            valueTotal: 5000,
          }
        }
      },
      pro_prop_list: {
        type: Array,
        default: ()=>{
          return [];
        }
      },
      error_info: {
        type: Object,
        default: ()=>{
          return {
            type: 0,
            msg: '',
            platform: '',
          }
        }
      }
    },
    watch: {
      popup_type: {
        handler(value) {
          this.currentStyle = value;
        },
        immediate: true,
        deep: true,
      },
      languageEnv: {
        async handler(value) {
          if(value){
            this.localesEnv = value;
          }
        },
        immediate: true,
        deep: true,
      },
      languagePackage: {
        async handler(value) {
          if(value){
            this.localesPackage = value;
          }
        },
        immediate: true,
        deep: true,
      }
    },
  
    computed: {
      ...mapState({
        languageEnv: (state) => state.global.languageEnv,
        languagePackage: (state) => state.global.languagePackage,
      }),
      divWidth: function () {
        const lineWidth = this.progressWidth - this.progressPadding;
        if (this.curKep === 500) {
          const width = lineWidth + "px";
          return width;
        } else {
          const width =
            ((this.curKep * lineWidth) / this.total_kep).toFixed(0) + "px";
          return width;
        }
      },
    },
    setup(props, { emit }) {
      const { popup_type, error_info } = props;
      /**语言包 - ref */
      const localesPackage = ref({});
      /**语言环境 - ref */
      const localesEnv = ref('en');
      const currentStyle = ref(popup_type); //当前样式
      const styleConfig = ref([]);
      onMounted(() => {
        // nextTick(() => {
          
        // });
        styleConfig.value = [ //样式盒子存放
          //升级Pro信息弹窗-POPUP_TYPE.UPGRADE
            {
              box: {
                style: [{
                  width: '350px',
                  height: '550px'
                }],
                class: ['box-upgrade-reward-style']
              },
              boxBg: {
                class: ['box-upgrade-reward-bg-style'],
              },
              title: localesPackage.value?.['og_upgrade_reward']?.[localesEnv.value],
              describe: 1,
            },
          //道具弹窗-POPUP_TYPE.PROP
            {
              box: {
                class: ['box-prop-style']
              },
              boxBg: {
                class: ['box-prop-bg-style'],
              },
              title: localesPackage.value?.['katharsis_reward']?.[localesEnv.value],
            },
            // ERROR弹窗
            {
              box: {
                class: ['box-prop-style']
              },
              boxBg: {
                class: ['box-prop-bg-style'],
              },
              title: localesPackage.value?.['og_opps']?.[localesEnv.value],
            },
            // OG首次弹窗
            {
              box: {
                class: ['box-prop-style']
              },
              boxBg: {
                class: ['box-prop-bg-style'],
              },
              title: localesPackage.value?.['og_congratulations']?.[localesEnv.value],
              desc: [
                localesPackage.value?.['og_congratulations_toast']?.[localesEnv.value],
                localesPackage.value?.['og_congratulations_toast2']?.[localesEnv.value]
              ]
            },
            //OG-如何成为OG弹窗
            {
              box: {
                class: ['box-prop-style']
              },
              boxBg: {
                class: ['box-prop-bg-style'],
              },
              title: localesPackage.value?.['og_get_method_title']?.[localesEnv.value],
              desc: [
                `${localesPackage.value?.['og_get_method_toast']?.[localesEnv.value]}`,
                `${localesPackage.value?.['og_get_method_toast2']?.[localesEnv.value]}`
              ],
              content: [
                localesPackage.value?.['og_get_method_toast3']?.[localesEnv.value],
                localesPackage.value?.['og_get_method_toast4']?.[localesEnv.value],
                localesPackage.value?.['og_get_method_toast5']?.[localesEnv.value],
              ]
            },
            //规则介绍
            {
              box: {
                class: ['box-prop-style']
              },
              boxBg: {
                class: ['box-prop-bg-style'],
              },
              title: localesPackage.value?.['katharsis_rules']?.[localesEnv.value],
              content: [
                [
                  {type: 'title',text: localesPackage.value?.['katharsis_rule_missions']?.[localesEnv.value]},
                  {type: 'desc',text: localesPackage.value?.['katharsis_rule_content1']?.[localesEnv.value]},
                  {type: 'desc',text: localesPackage.value?.['katharsis_rule_content2']?.[localesEnv.value]},
                ],
                [
                  {type: 'title',text: localesPackage.value?.['katharsis_rule_level']?.[localesEnv.value]},
                  {type: 'desc',text: localesPackage.value?.['katharsis_rule_content3']?.[localesEnv.value]},
                  {type: 'desc',text: localesPackage.value?.['katharsis_rule_content4']?.[localesEnv.value]},
                ],
                [
                  {type: 'title',text: localesPackage.value?.['katharsis_rule_kep_limit']?.[localesEnv.value]},
                  {type: 'desc',text: localesPackage.value?.['katharsis_rule_content5']?.[localesEnv.value]},
                ],
              ]
            },
        ]
      });
      const closeHandle = () => {
        emit('infoHandle',false);
        ogInfoHandle('close');
      }
      const confirmHanle = () => {
        emit('infoHandle','confirm');
      }
      const infoHandle = (info) => {
        emit('infoHandle', info);
      }
      const ogInfoHandle = (info) => {
        emit('ogInfoHandle', info);
      }
      const errorClose = () => {
        emit('infoHandle',false);
        ogInfoHandle('close');
      }
      /**
       * 防抖
       */
      function debounce(fun, delay) {
        return function (args) {
          let that = this;
          let _args = args;
          clearTimeout(fun.id);
          fun.id = setTimeout(function () {
            fun.call(that, _args);
          }, delay);
        };
      }
      return {
        closeHandle,
        confirmHanle,
        infoHandle,
        ogInfoHandle,
        errorClose,
        debounce,
        styleConfig,
        currentStyle,
        localesPackage,
        localesEnv
      };
    },
  };
  </script>
  
  <style lang="less" scoped>
    .popup{
        width: 100%;
        height: 100%;
        margin-top: -60px;
        overflow: hidden;
        position: fixed;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 999;
        .mask {
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.8);
            top: 0;
            left: 0;
            // animation: maskFade 0.15s ease-in-out both;
        }
        @keyframes maskFade {
            0% {
            background: rgba(0, 0, 0, 0);
            }
            100% {
            background: rgba(0, 0, 0, 0.8);
            }
        }
        .box{
          position: relative;
          margin: auto;
          background: #F6FAFD;
          border-radius: 10px;
          &-title{
            color: #484c58;
            font-size: 18px;
            font-weight: 500;
            font-family: "PingFang SC";
            z-index: 1;
            position: absolute;
            top: 8px;
            left: 50%;
            transform: translateX(-50%);
          }
          &-describe{
            width: 289px;
            height: 38px;
            color: #484c58ff;
            font-size: 14px;
            font-weight: 600;
            font-family: "PingFang SC";
            text-align: left;
            line-height: 19.2px;
            position: absolute;
            top: 64px;
            left: 33px;
            &-up-text{
              color: #FC9823;
            }
          }
          &-describe-prop{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 77px;
            &-item{
              width: 71px;
              height: 71px;
              border-radius: 4px;
              border: 2px solid #000000ff;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 11px;
              div{
                margin-bottom: unset;
              }
            }
            &-title{
              height: 19px;
              color: #2e2e2e;
              font-size: 16px;
              font-weight: 600;
              font-family: "PingFang SC";
              margin-bottom: 16px;
            }
            &-describe{
              width: 275px;
              color: #484c58;
              font-size: 13px;
              font-weight: 500;
              font-family: "PingFang SC";
            }
          }
          &-describe-error{
            padding: 59px 57px;
            padding-bottom: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            &-msg{
              min-height: 42px;
              font-size: 15px;
              font-weight: 500;
              text-align: left;
              font-family: 'PingFang SC';
              margin-bottom: 45px;
            }
            img{
              width: 120px;
              height: 120px;
            }
          }
          &-describe-congratulate{
            font-family: 'PingFang SC';
            color: #484C58;
            text-align: left;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 60px 37px;
            padding-bottom: 0;
            &-title{
              font-size: 16px;
              font-weight: 600;
              margin-bottom: 12px;
              line-height: 22px;
            }
            &-text{
              font-size: 13px;
              font-weight: 500;
              margin-bottom: 2px;
            }
            img{
              width: 100px;
              height: 100px;
            }
          }
          &-describe-howto{
            font-family: 'PingFang SC';
            text-align: left;
            color: #484C58;
            padding: 0 22px;
            // padding-bottom: 0;
            position: absolute;
            z-index: 1;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            height: auto;
            max-height: 284px;
            overflow-y: scroll;
            &-desc{
              font-size: 14px;
              font-weight: 500;
              div{
                margin-bottom: 9px;
              }
            }
            &-content{
              font-size: 14px;
              font-weight: 400;
              margin-top: 15px;
              &-box{
                margin-bottom: 10px;
                position: relative;
                padding: 1px 0;
                padding-left: 10px;
                height: auto;
                background: linear-gradient(90deg, #cdd1d800 0%, #cdd1d866 51%, #cdd1d800 100%);
              }
              &-box::before{
                content: url('~@/assets/images/YuliApp/weeklyTask/hint.svg');
                position: absolute;
                width: 12px;
                height: 12px;
                top: 0;
                left: -6px;
              }
            }
          }
          &-describe-rules{
            font-family: 'PingFang SC';
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: left;
            color: #484C58;
            width: 100%;
            height: 270px;
            top: 54px;
            padding: 64px 22px 0 46px;
            box-sizing: border-box;
            overflow: hidden;
            overflow-y: scroll;
            z-index: 10;
            position: absolute;
            &-textgroup{
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              &-title{
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 3px;
                position: relative;
              }
              &-title::before{
                content: '';
                width: 7px;
                height: 7px;
                position: absolute;
                top: 6px;
                left: -18px;
                border-radius: 50%;
                background: #494C52;
              }
              &-desc{
                font-size: 13px;
                font-weight: 400;
                line-height: 20px;
              }
              &-desc:last-child{
                margin-bottom: 10px;
              }
            }
          }
          &-reward-title{
            position: absolute;
            width: 90%;
            top: 134px;
            left: 50%;
            transform: translateX(-50%);
            color: rgba(46, 46, 46, 1);
            font-size: 14px;
            font-weight: 600;
            height: 31px;
            line-height: 31px;
            background: linear-gradient(90deg,rgba(245, 249, 252, 0.9) 0%,rgba(231, 235, 238, 1) 50%,rgba(245, 249, 252, 0.9) 100%);
          }
          &-count{
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: space-between;
            bottom: 80px;
            right: 24px;
            span{
              color: rgb(79, 83, 86);
              font-size: 14px;
              font-weight: 500;
              font-family: "PingFang SC";
            }
            img{
              margin-left: 5px;
              width: 34px;
              height: 34px;
            }
          }
          &-rewardBox{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-start;
            width: 310px;
            height: 241px;
            border-radius: 4px;
            background: rgba(231, 235, 239, 0.7);
            position: absolute;
            top: 178px;
            left: 50%;
            transform: translateX(-50%);
            overflow: hidden;
            overflow-y: scroll;
            padding: 9px 26px 9px 41px;

            padding-bottom: 0;
            box-sizing: border-box;
          }
          &-single{
            justify-content: center;
            div{
              scale: 1.5;
            }
          }
          &-buttonView{
            width: 80%;
            height: 38px;
            position: absolute;
            bottom: 14px;
            left: 10%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &-button{
              width: 128px;
              height: 38px;
              border-radius: 30px;
              opacity: 1;
              background: rgb(79, 83, 86);
              color: rgb(255, 255, 255);
              font-size: 16px;
              font-weight: 600;
              font-family: "PingFang SC";
              text-align: center;
              line-height: 38px;
            }
            &-confirm{
              background: rgba(66, 59, 106, 1);
            }
            &-prop{
              width: auto;
              padding: 0 27px;
              background: rgba(66, 59, 106, 1);
            }
            &-error{
              width: auto;
              padding: 0 27px;
            }
            &-og_con{
              width: 248px;
              background: rgba(66, 59, 106, 1);
            }
          }
          &-prop-buttonView{
            justify-content: center;
          }
          &-bg{
            position: absolute;
          }
          &-closeIcon{
            width: 42px;
            height: 42px;
            position: absolute;
            top: -1px;
            right: 21px;
            z-index: 20;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .box-upgrade-reward-style{
          width: 350px;
          height: 550px;
          // margin-top: 130px;
        }
        .box-upgrade-reward-bg-style{
          width: 350px;
          height: 550px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .box-prop-style{
          width: 350px;
          height: 390px;
        }
        .box-prop-bg-style{
          width: 350px;
          height: 390px;
          img{
            width: 100%;
            height: 100%;
          }
        }
    }
  </style>
  